import {
  CustomLayoutInput,
  ResolvableBooleanInput,
  SectionInput,
} from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { DocumentEditorCmp_RecursiveSection } from '../fragments/recursive-section.fragment';

import { templateForm2ApiMapper } from './template.form2api.mapper';

export function recursiveSectionForm2ApiMapper(
  section: Readonly<
    | DocumentEditorCmp_RecursiveSection
    | ReturnType<typeof pruneInput<SectionInput>>
  >,
): SectionInput {
  const sectionInput = pruneInput(section, SectionInput);

  const customLayouts = section.customLayouts?.map((layout) =>
    pruneInput(layout, CustomLayoutInput),
  );

  return {
    ...sectionInput,
    customLayouts,
    displayCondition: section.displayCondition
      ? pruneInput(section.displayCondition, ResolvableBooleanInput)
      : null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    title: sectionInput.title || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    content: sectionInput.content || null,
    subSections: sectionInput.subSections.map(recursiveSectionForm2ApiMapper),
    ...(section.template
      ? { template: templateForm2ApiMapper(section.template) }
      : {}),
  };
}
